import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../i18n";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Chapters } from "../components/Chapters";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";

export default function Home() {
  const { t } = useLanguage();

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Chapters />
      <section data-testid="home-menu-cta" className="max-w-7xl mx-auto px-6 lg:px-10 pb-28 md:pb-40">
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl border border-line bg-surface px-8 py-14 md:px-16 md:py-20">
            <p className="text-xs tracking-[0.35em] uppercase text-terra" data-testid="home-cta-kicker">{t("home_cta_kicker")}</p>
            <h2 className="font-serif text-4xl md:text-6xl text-ink mt-4 max-w-3xl" data-testid="home-cta-title">{t("home_cta_title")}</h2>
            <Link
              to="/menu"
              data-testid="home-cta-menu-button"
              className="mt-10 inline-flex items-center gap-3 rounded-full bg-terra px-8 py-4 text-xs tracking-[0.22em] uppercase text-cream font-semibold hover:bg-ink transition-colors duration-300"
            >
              {t("home_cta_button")} <ArrowRight size={14} />
            </Link>
          </div>
        </Reveal>
      </section>
      <Footer />
    </main>
  );
}
